/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useContext, useRef, useState } from "react";
import Page from "components/common_components/Page";
import I9 from "./components/forms/immigration/I-9/I9";
import FormsContext from "./FormsContext";
import { useHistory, useParams } from "react-router-dom";
import Button from "components/common_components/Button";
import FormActions from "./form-actions";
import { useDispatch } from "react-redux";
import { notifyError } from "redux/actions/Notifications";
import LoadingPage from "components/common_components/LoadingPage";
import Status from "components/common_components/Status";
import Icon from "components/common_components/Icon";
import { ConfirmDialog } from "components/common_components/Dialogs";

const ViewForm = () => {
    const { id } = useParams();
    const iframeRef = useRef(null);
    const history = useHistory();
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const [formClient, setFormClient] = useState(undefined);
    const { FormClients } = useContext(FormsContext);
    const [confirmDialogProps, setConfirmDialogProps] = useState({
        open: false,
        title: "",
        content: "",
        primaryButtonText: "",
        onPrimaryClick: undefined,
        secondaryButtonText: "Cancel",
        onSecondaryClick: () => setConfirmDialogProps((prev) => ({ ...prev, open: false })),
        onClose: () => setConfirmDialogProps((prev) => ({ ...prev, open: false })),
    });

    useEffect(() => {
        if (id) {
            setIsLoading(true);
            FormClients.getOneById({ id, onSuccess, onError });
        } else {
            dispatch(notifyError("No ID included in the path."));
            setFormClient(undefined);
            history.push("/forms");
        }

        return () => setFormClient(undefined);
    }, [id]);

    const onSuccess = (data) => {
        setFormClient(data);
        setIsLoading(false);
    };

    const onError = (error) => {
        dispatch(notifyError(error.message || error));
        setIsLoading(false);
        history.push(`/forms`);
    };

    useEffect(() => {
        if (formClient) {
            setTimeout(() => {
                iframeRef.current?.contentWindow.postMessage(
                    { action: FormActions.LOAD_FORM_CLIENT, formClient, mode: "view" },
                    window.location.origin
                );
            }, 1000);
        }
    }, [formClient]);

    const onEditHandler = () => {
        if (formClient.status !== "completed") {
            history.push(`/forms/${id}/edit`);
        } else {
            setConfirmDialogProps((prev) => ({
                ...prev,
                open: true,
                title: "Form Completed",
                content: "This form is COMPLETED. Do you want to edit its content anyway?",
                primaryButtonText: "Yes, edit",
                onPrimaryClick: () => {
                    history.push(`/forms/${id}/edit`);
                    prev.onClose();
                },
            }));
        }
    };

    const onCancelHandler = () => history.push(`/forms`);

    return (
        <Page className="view-form-page">
            {isLoading ? (
                <LoadingPage />
            ) : (
                <>
                    {formClient && (
                        <div className="form-head">
                            <div className="item back">
                                <Button secondary link small onClick={onCancelHandler}>
                                    <Icon name="arrow" size="sm" color="secondary" />
                                    <span>Back</span>
                                </Button>
                            </div>
                            <div className="item form-status">
                                <Status id={formClient.status} withIcon />
                            </div>
                            <div className="item">{formClient.form?.category}</div>
                            <div className="item">
                                {formClient.form?.code}
                                <span>({formClient.form?.version})</span>
                                {formClient.form?.isCurrent ? <Status id="active" /> : <Status id="oldVersion" />}
                            </div>
                            <div className="item">{formClient.client?.fullName}</div>
                            <div className="item form-actions">
                                <Button secondary small onClick={onEditHandler}>
                                    <Icon name="pencil" size="md" color="white" />
                                    <span>Edit</span>
                                </Button>

                                <Button secondary outline small onClick={onCancelHandler}>
                                    Cancel
                                </Button>
                            </div>
                        </div>
                    )}
                    <I9 ref={iframeRef} />
                    <ConfirmDialog {...confirmDialogProps} />
                </>
            )}
        </Page>
    );
};

export default ViewForm;
